import { useTranslation } from "react-i18next";

import { Alert, Stack, Typography } from "@mui/material";
import { FormikProps } from "formik";

import { FormikYesNoAutocomplete } from "../../../../../../formik/FormikYesNoAutocomplete";
import { nameof } from "../../../../../../utils/nameof";
import { IncomeSectionCard } from "../../../income/components/income-section-card/IncomeSectionCard";
import { AssetOwnClaimsFormValues } from "../../OwnClaimsView.types";

const SECTION = "clients.client.debtSettlement.assetInventory.ownClaimsTab.entry";

interface Props {
  formik: FormikProps<AssetOwnClaimsFormValues>;
}

export function EntryQuestionSection({ formik }: Props) {
  const { t } = useTranslation();

  return (
    <IncomeSectionCard title={t(`${SECTION}.title`)}>
      <Alert severity="info">
        <Stack gap={1}>
          <Typography variant="body2">{t(`${SECTION}.infoOwed`)}</Typography>
          <Typography variant="body2">{t(`${SECTION}.infoPending`)}</Typography>
        </Stack>
      </Alert>
      <FormikYesNoAutocomplete
        id="own-claims-has-own-claims"
        formik={formik}
        fieldName="hasOwnClaims"
        label={t(`${SECTION}.hasOwnClaims`)}
        onValueChange={(value) => {
          if (value !== true) {
            void formik.setFieldValue(nameof<AssetOwnClaimsFormValues>("ownClaims"), []);
          }
        }}
      />
    </IncomeSectionCard>
  );
}
